// extracted by mini-css-extract-plugin
export default {"Cofounder":"CoFounder_Cofounder__b5SbL","paraName":"CoFounder_paraName__C522B"};